import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import ReservationDetails from 'components/ReservationDetails';
import {
  numberOfNightsSelector,
  propertySelector
} from 'routes/DateSelection/selectors';
import { selectedRoomSelector } from 'routes/ChooseAccommodation/selectors';

const mapStateToProps = createStructuredSelector({
  numberOfNights: numberOfNightsSelector,
  selectedRoom: selectedRoomSelector,
  property: propertySelector
});

export default connect(mapStateToProps)(ReservationDetails);
